<mat-nav-list>
  <h3 class="subheader">
    Prestaties
    @if (!prestatiesPage.isEmpty()) {
      <zah-sort-button
        [sortOrder]="initialPageRequest.getSortOrder()"
        (sortOrderChange)="onSortOrderChange($event)">
      </zah-sort-button>
    }
  </h3>
  @for (prestatie of prestatiesPage.getItems(); track prestatie; let isLast = $last) {
    <mat-list-item (click)="onPrestatieClick(prestatie)">
      <div matListItemTitle
        [class.deleted-user]="getThuisverzorger(prestatie.getThuisverzorgerId()).isVerwijderd()">{{ getThuisverzorger(prestatie.getThuisverzorgerId()).getNaam() }}
        <span class="mat-small"> ({{ getThuisverzorger(prestatie.getThuisverzorgerId()).getPersoneelsnummer() }})</span>
      </div>
      <div matListItemLine class="mat-small">{{ prestatie.getStartTijdstip() | date:'d MMMM yyyy' }}</div>
    </mat-list-item>
    @if (!isLast) {
      <mat-divider></mat-divider>
    }
  }
  @if (prestatiesPage.isEmpty()) {
    <mat-list-item
      class="no-list-item-highlight"
      disableRipple>
      <div matListItemTitle>Geen prestaties gevonden</div>
    </mat-list-item>
  }
</mat-nav-list>
@if (!prestatiesPage.isEmpty()) {
  <zah-paginator
    [currentPage]="prestatiesPage"
    [pageSize]="initialPageRequest.getPageSize()"
    (pageSizeChange)="onPageSizeChange($event)"
    (pageChange)="onPageChange($event)">
  </zah-paginator>
}
